import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden pt-[72px]"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-accent-100/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-primary-50/30 rounded-full blur-3xl translate-y-1/4 -translate-x-1/4"></div>

      <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold bg-accent-100 text-accent-800 mb-4 md:mb-5">
              <i className="ri-fire-line text-sm"></i>
              {heroData.tag}
            </span>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950 leading-tight mb-2 md:mb-3">
              黑料视频 · 全网吃瓜爆料视频聚合平台
            </h1>

            <p className="text-base md:text-lg text-foreground-500 font-heading mb-4 md:mb-5">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-6 md:mb-7">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-7">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-lg md:text-xl font-bold font-heading text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href={heroData.primaryCta.href}
                onClick={(e) => handleClick(e, heroData.primaryCta.href)}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                {heroData.primaryCta.text}
              </a>
              <a
                href={heroData.secondaryCta.href}
                onClick={(e) => handleClick(e, heroData.secondaryCta.href)}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg border-2 border-primary-500 text-primary-500 font-semibold text-sm hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-line text-lg"></i>
                {heroData.secondaryCta.text}
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-accent-400/20 via-primary-400/10 to-accent-300/20 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Entertainment%20news%20studio%20with%20dramatic%20warm%20lighting%2C%20multiple%20video%20screens%20displaying%20breaking%20news%2C%20professional%20broadcast%20equipment%2C%20red%20and%20gold%20accent%20colors%2C%20modern%20media%20production%20environment%2C%20cinematic%20atmosphere%2C%20gossip%20and%20entertainment%20news%20theme%2C%20no%20people%2C%20abstract%20broadcast%20concept&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="黑料视频 — 最新吃瓜爆料视频聚合平台，高清在线观看"
                className="relative w-full h-auto rounded-2xl object-cover"
                style={{ aspectRatio: '4/3' }}
              />
              <div className="absolute -bottom-3 -right-3 bg-accent-500 text-background-50 text-xs font-bold px-4 py-2 rounded-lg whitespace-nowrap">
                7×24 小时更新
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}